import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/sites/$siteId/')({
  component: lazyRouteComponent(() => import('&/features/settings/sites/pages/site-general-page')),
});
